import { borderRadius, SmartTable, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const TitleLabel = styled.div`
  ${typographyV2.titleMd};
`;

export const DescriptionLabel = styled.div`
  ${typographyV2.bodySm};
  color: var(--text-soft);
`;

export const TableWrapper = styled.div`
  ${SmartTable.Styled.StyledTableRow} {
    cursor: default;
  }

  tbody ${SmartTable.Styled.StyledTableRow}:last-child td {
    border-bottom: none;
  }

  ${borderRadius.r2};
  border: 1px solid var(--border-soft);
  overflow: hidden;
`;
